// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-nav[data-v-45a3652c]{position:fixed;bottom:0;z-index:11}.details-mobile[data-v-45a3652c]{height:100vh;z-index:10}", ""]);
// Exports
module.exports = exports;
